import { FormControl, FormHelperText, Grid2 as Grid, InputLabel, MenuItem, Select } from "@mui/material";

type SelectProps = {
    id: string,
    label: string,
    value: any,
    setValue: (v: any) => void,
    items: string[],
    itemValues?: any[] | undefined,
    error?: string,
    disabled?: boolean,
    required?: boolean,
    resettable?: boolean,
    sxProps?: {[key: string]: string},
    size?: number
}

const FormSelect = (
    {
        id,
        label,
        value,
        setValue,
        items,
        itemValues = [],
        error = "",
        disabled = false,
        required = false,
        resettable = true,
        sxProps = {},
        size = 4
    }: SelectProps
) => {
    return (
        <Grid size={size} sx={sxProps}>
            <FormControl fullWidth>
                <InputLabel id={id}>{label}</InputLabel>
                <Select
                    labelId={id}
                    value={value}
                    label={label}
                    disabled={disabled}
                    required={required}
                    error={error !== ""}
                    onChange={(e) => { setValue(e.target.value) }}
                >
                    { resettable && <MenuItem value=""><em>None</em></MenuItem> }
                    {items.map((item, index) => {
                        return (
                            <MenuItem key={item} value={itemValues.length > 0 ? itemValues[index] : item}>
                                {item}
                            </MenuItem>
                        )
                    })}
                </Select>
                <FormHelperText sx={{ color: '#f44336' }}>{error}</FormHelperText>
            </FormControl>
        </Grid>
    )
}

export default FormSelect;
